// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"227":"chunk-floating-music","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"227":"fec43133e589d2d5bbe7","293":"a737b60034df43df3524","522":"634e12a74372e6c75f7e"}[chunkId] + ".js";
};